import createInteractionAction from './InteractionAction'

export const getActionName = (action) => action.constructor.displayName || action.constructor

export const createActionList = (actions) => actions.map((action) => createInteractionAction({ action }))
